import { gsap } from 'gsap/gsap-core';
type VideoPlayerCallback = () => void;

interface VideoPlayerConfig {
  // videoSelector: string;
  videoContainer: HTMLElement;
  // playButtonSelector?: string;
  onEndCallback?: VideoPlayerCallback;
}

export class VideoPlayer {
  private videoContainer: HTMLElement;
  private videoElement: HTMLVideoElement;
  private playButtonOverlay: HTMLElement | null;

  /**
   * Create a new VideoPlayer instance.
   * @param config - Configuration object for the video player.
   */
  constructor(config: VideoPlayerConfig) {
    this.videoContainer = config.videoContainer as HTMLElement;

    const element = this.videoContainer.querySelector("[cc-element='video-player-embed']");
    if (!element || !(element instanceof HTMLVideoElement)) {
      throw new Error(`No video element found for selector: ${config.videoContainer}`);
    }
    this.videoElement = element;

    this.playButtonOverlay = this.videoContainer.querySelector(
      '[cc-element="video-player-button"]'
    );
    gsap.from(this.videoElement, { opacity: 0, duration: 0.5 });
    this.bindEvents(config.onEndCallback);
  }

  private bindEvents(onEndCallback?: VideoPlayerCallback): void {
    if (onEndCallback) {
      this.videoElement.addEventListener('ended', onEndCallback);
    }

    // Toggle play/pause when the video is clicked
    this.videoElement.addEventListener('click', this.togglePlayPause.bind(this));

    if (this.playButtonOverlay) {
      this.playButtonOverlay.addEventListener('click', (event) => {
        event.stopPropagation(); // prevent triggering the video element's click event
        this.togglePlayPause();
      });
    }
  }

  /**
   * Play the video and hide the overlay.
   */
  public play(): void {
    this.videoElement.play();
    if (this.playButtonOverlay) {
      //   this.playButtonOverlay.style.display = 'none';
      gsap.to(this.playButtonOverlay, { opacity: 0, duration: 0.3, display: 'none' });
    }
    gsap.to(this.videoElement.parentElement, { opacity: 1, duration: 2 });
  }
  /**
   * Play the video and hide the overlay.
   */
  public hideContainer(): void {
    this.pause();

    gsap.to(this.videoContainer, { display: 'none' });
  }

  /**
   * Pause the video and show the overlay.
   */
  public pause(): void {
    console.log('pause');
    this.videoElement.pause();
    if (this.playButtonOverlay) {
      gsap.to(this.playButtonOverlay, { opacity: 1, duration: 0.3, display: 'flex' });
    }
    gsap.to(this.videoElement.parentElement, { opacity: 1, duration: 1 });
  }

  /**
   * Toggle the video play/pause state.
   */
  public togglePlayPause(): void {
    if (this.videoElement.paused) {
      this.play();
    } else {
      this.pause();
    }
  }

  // ... [rest of the methods remain unchanged]
}
